// extracted by mini-css-extract-plugin
export default {"preview":"qNApD","lg":"MEJZE","sm":"dXBBC","inner":"RwFQC","header":"tG3om","logo":"qdi1X","icon":"Gpm8e","toolbar":"I9xL2","theoryLessonInner":"vncUl"};